import { render, staticRenderFns } from "./UnrollerList.vue?vue&type=template&id=e8183db4&scoped=true"
import script from "./UnrollerList.vue?vue&type=script&lang=js"
export * from "./UnrollerList.vue?vue&type=script&lang=js"
import style0 from "./UnrollerList.vue?vue&type=style&index=0&id=e8183db4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8183db4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WButton: require('/skade-pwa/components/ui/atom/WButton/WButton.vue').default,Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
